import {ISectionState} from "src/context/models/Section";

export default {
    loading: false,
    data: null,
    error: null
} as ISectionState;
